export default "__VITE_ASSET__d1f04a85__"